import type { ManageEvent } from '../manage-events.slice'

export let categoryString = (category: ManageEvent['category']): string =>
  typeof category === 'string' ? category : category.other

export let displayCategoryName = (
  category: ManageEvent['category'],
  nameMap: Record<string, string>,
): string => {
  let raw = categoryString(category)
  return nameMap[raw.toLowerCase()] ?? raw
}
